module.exports = __webpack_public_path__ + "img/swipe.e50fa04c.png";